import { Column } from '@/fsd/entities/table/model/types/Column';

export const getRemainsTableTotalItemWidth = (columns: Column[]) => {
  return columns.reduce((accumulator, column) => {
    if (
      column.isVisible &&
      (column.id === 'product_id' ||
        column.id === 'photo_url' ||
        column.id === 'name')
    ) {
      return accumulator + Number(column.width) + 10;
    } else {
      return accumulator;
    }
  }, -10);
};
